import Crud from '../views/CareLine/Crud'
import Entity from '../views/CareLine/Add'

let routes = {
    path: '/care_line',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/care_lines/add',
            name: 'NewCareLine',
            component: Entity,
            meta: {
                pageTitle: 'Linha de Cuidado',
                access_nivel: ['6', '2'],
                breadcrumb: [
                    {
                        text: 'Adicionar Linha de Cuidado',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/care_lines/edit/:id?',
            name: 'EditCareLine',
            component: Entity,
            meta: {
                pageTitle: 'Linha de Cuidado',
                access_nivel: ['6', '2'],
                breadcrumb: [
                    {
                        text: 'Editar Linha de Cuidado',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/care_lines',
            name: 'list-care-lines',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Linha de Cuidados',
                access_nivel: ['6', '2'],
                breadcrumb: [
                    {
                        text: 'Linha de Cuidados',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
